import React from "react"
import {FieldControlViewProps} from "../../render/control-view"

export default function FieldProto_ControlView(props: FieldControlViewProps) {

    return (
        <div className="ui5-txt-default ui5-txt-red">{props.field.type}.controlView</div>
    )
}